// ui.jsx — Shared primitive UI: Avatar, Inp, Btn
// Used by Login, Settings, AdminPanel, MfaSetupModal.
// Reads active theme via useTheme() — always matches current theme.

import React from 'react';
import { useTheme } from '../constants';

export function Avatar({ u, size = 32 }) {
  const C = useTheme();
  const initials = u?.username ? u.username.slice(0, 2).toUpperCase() : '??';
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: u?.color || C.accent, flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.38, fontWeight: 700, color: '#0A0C10' }}>
      {u?.avatar?.startsWith('http') ? <img src={u.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/> : initials}
    </div>
  );
}

export function Inp({ label, value, onChange, type = 'text', placeholder, onKeyDown }) {
  const C = useTheme();
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <div style={{ color: C.muted, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 5 }}>{label}</div>}
      <input className="tv-input" type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        onKeyDown={onKeyDown}
        style={{ width: '100%', padding: '11px 14px', borderRadius: 10, background: C.inputBg || '#0D0F14', border: `1px solid ${C.border}`, color: C.text, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', transition: 'border-color 0.2s, box-shadow 0.2s' }}/>
    </div>
  );
}

export function Btn({ children, onClick, variant = 'primary', disabled }) {
  const C = useTheme();
  const styles = {
    primary: { background: disabled ? '#1A2A2A' : `linear-gradient(90deg,#00B896,${C.accent})`, color: disabled ? C.muted : '#0A0C10' },
    ghost:   { background: C.card, border: `1px solid ${C.border}`, color: C.text },
    danger:  { background: 'transparent', border: '1px solid #EF444433', color: '#EF4444' },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{ width: '100%', padding: '12px 0', borderRadius: 10, border: 'none', fontSize: 14, fontWeight: 700, cursor: disabled ? 'default' : 'pointer', fontFamily: 'inherit', marginBottom: 6, transition: 'all 0.2s', ...styles[variant] }}>
      {children}
    </button>
  );
}
